//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The adyen payment methods enum
*
* 
*  * CREDIT_CARD value: card - credit card 
*  * GOOGLEPAY value: googlepay - google pay (GPay) 
*  * APPLEPAY value: applepay - apple pay 
*  * PAY_BY_BANK value: paybybank - Pay by Bank 
*  * IDEAL value: ideal - ideal payment -&gt; later it will be converted to WERO 
*  * EPS value: eps - eps payment 
*/
@Serializable
enum class AdyenPaymentMethod(val value: kotlin.String) {

    @SerialName(value = "card")
    CREDIT_CARD("card"),

    @SerialName(value = "googlepay")
    GOOGLEPAY("googlepay"),

    @SerialName(value = "applepay")
    APPLEPAY("applepay"),

    @SerialName(value = "paybybank")
    PAY_BY_BANK("paybybank"),

    @SerialName(value = "ideal")
    IDEAL("ideal"),

    @SerialName(value = "eps")
    EPS("eps");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is AdyenPaymentMethod) "$data" else null

    /**
    * Returns a valid [AdyenPaymentMethod] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): AdyenPaymentMethod? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

